<template>
  <div class="container-sections" v-loading="getLoading" :element-loading-text="$t('portals.list.chargementDonnees')">
    <div>
      <h4>{{ $t("statisticsDBKS.statusOfBroadcasts") }}</h4>
    </div>
    <div class="top-section">
      <div class="doughnut-component" >
        <DoughnutChart :chartData="getDoughnutChartCounts" :chartOptions="getDoughnutChartOptions" />
        <div class="total-stats">
          <h2 class="title-total">{{ $t('statisticsDBKS.total') }}</h2>
          <span class="number-total">{{ getStatisticsDBKSTotalCount }}</span>
        </div>
      </div>
    </div>
    <div class="bottom-section">
      <div class="container-tabs">
        <div class="bottom-section-column" @click="activeTabs = 'SENT'">
          <p class="color-sent number-categories-stats">{{ getStatisticsDBKSCSENTCount }}</p>
          <p>{{ $t('statisticsDBKS.broadcast') }}</p>
          <span :class="(activeTabs === 'SENT')?  'border-color-sent': ''"></span>
        </div>
        <div class="bottom-section-column" @click="activeTabs = 'NEW'">
          <p class="color-new number-categories-stats">{{ getStatisticsDBKSNEWCount }}</p>
          <p>{{ $t('statisticsDBKS.inProgress') }}</p>
          <span :class="(activeTabs === 'NEW')? 'border-color-new' : ''"></span>
        </div>
        <div class="bottom-section-column" @click="activeTabs = 'ERROR'">
          <p class="color-error number-categories-stats">{{ getStatisticsDBKSERRORCount }}</p>
          <p>{{ $t('statisticsDBKS.broadCastError') }}</p>
          <span :class="(activeTabs === 'ERROR')? 'border-color-error' : ''"></span>
        </div>
      </div>
    </div>
    <div class="container-icons">
      <div v-for="(media, index) in getStatisticsDBKS" :key="index">
        <div class="circle-bg-sent">
          <el-tooltip class="item" effect="dark" :content="media.infos.name" placement="bottom-start">
            <img :src="require(`@/assets/dbksStats/${media.infos.logo}`)" :alt="media.infos.name" width="30px"
                 style="margin-bottom: 10px"/>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '@/chart/DoughnutChart.vue'

export default {
  name: 'StatsDBKS',
  components: {
    DoughnutChart
  },
  data () {
    return {
      activeTabs: 'SENT'
    }
  },
  computed: {
    getStatisticsDBKS () {
      switch (this.activeTabs) {
        case 'ERROR':
          return this.$store.getters['statisticsDBKS/getStatsERROR']
        case 'NEW':
          return this.$store.getters['statisticsDBKS/getStatsNEW']
        default:
          return this.$store.getters['statisticsDBKS/getStatsSENT']
      }
    },
    getLoading () {
      return this.$store.getters['statisticsDBKS/getLoadingDBKS']
    },
    getStatisticsDBKSCSENTCount () {
      return this.$store.getters['statisticsDBKS/getStatsSENTCount']
    },
    getStatisticsDBKSNEWCount () {
      return this.$store.getters['statisticsDBKS/getStatsNEWCount']
    },
    getStatisticsDBKSERRORCount () {
      return this.$store.getters['statisticsDBKS/getStatsERRORCount']
    },
    getStatisticsDBKSTotalCount () {
      return this.$store.getters['statisticsDBKS/getStatsTOTALCount']
    },
    getDoughnutChartOptions () {
      return {
        responsive: true,
        lineTension: 1,
        scales: {
          y: {
            beginAtZero: true,
            padding: 25
          }
        }
      }
    },
    getDoughnutChartCounts () {
      const stats = this.$store.getters['statisticsDBKS/getStatsDBKS']

      if (stats && 'results' in stats) {
        const statsWithoutTotal = this.$store.getters['statisticsDBKS/getStatsDBKS'].results.counts
        const filteredStats = Object.entries(statsWithoutTotal).filter(
          ([key]) => key !== 'TOTAL'
        )
        const status = filteredStats.map(([key]) => key)
        const values = filteredStats.map(([, value]) => value)
        const newStatus = status.map(status => {
          switch (status) {
            case 'ERROR':
              return 'Erreur de diffusion'
            case 'NEW':
              return 'En cours de diffusion'
            case 'SENT':
              return 'Diffusé'
            default:
              return status
          }
        })
        return {
          labels: newStatus,
          datasets: [
            {
              label: '',
              data: values,
              backgroundColor: ['#F0921E', '#00a4bd', '#D24554'],
              hoverBackgroundColor: ['#F0921E', '#00a4bd', '#D24554'],
              borderWidth: 1
            }
          ]
        }
      } else {
        return {
          labels: [],
          datasets: []
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.color-new {
  color: #00a4bd;
}

.color-error {
  color: #D24554;
}

.color-sent {
  color: #F0921E;
}

.number-categories-stats {
  font-size: 20px;
  font-weight: bold;
}

// Stats DBKS
.container-sections {
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  font-size: 16px;

  .top-section {
    padding: 10px;
    .doughnut-component{
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
      .total-stats {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        margin-top: 25px;

        .title-total {
          font-family: "Open Sans", Helvetica, Arial, sans-serif;
          font-weight: bold;
          font-size: 15px;
        }

        span {
          font-weight: bold;
          font-size: 15px;
        }
      }
    }
  }

  .bottom-section {
    display: flex;
    justify-content: space-between;

    .container-tabs {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }

    &-column {
      width: 33.3%;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;

      .border-color-error {
        margin-top: -1rem;
        margin-bottom: 1rem;
        width: 50%;
        border-bottom: 2px solid #D24554;
      }

      .border-color-new {
        margin-top: -1rem;
        margin-bottom: 1rem;
        width: 50%;
        border-bottom: 2px solid #00a4bd;
      }

      .border-color-sent {
        margin-top: -1rem;
        margin-bottom: 1rem;
        width: 50%;
        border-bottom: 2px solid #F0921E;
      }
    }
  }
}

.circle-bg-sent {
  position: relative;
  width: 34px;
  height: 34px;
  background-color: #f0f0f0;
  border-radius: 50%;
  margin-bottom: 5px;
  overflow: hidden;
  border: 2px solid #F0921E;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}

.circle-bg-new {
  position: relative;
  width: 34px;
  height: 34px;
  background-color: #f0f0f0;
  border-radius: 50%;
  margin-bottom: 5px;
  overflow: hidden;
  border: 2px solid #00a4bd;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}

.circle-bg-error {
  position: relative;
  width: 34px;
  height: 34px;
  background-color: #f0f0f0;
  border-radius: 50%;
  margin-bottom: 5px;
  overflow: hidden;
  border: 2px solid #D24554;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}

.container-icons {
  height: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
